import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Core } from "@faire/design-tokens";
import { DefaultTheme } from "../Theme";
import { eventsThemeColors } from "../Theme/eventsThemeColors";
export var pillEventsTheme = _object_spread_props(_object_spread({}, DefaultTheme.pills), {
    filter: {
        primary: {
            color: eventsThemeColors.faireMarket.primaryLight,
            hover: eventsThemeColors.faireMarket.primaryDark,
            contrast: eventsThemeColors.faireMarket.promoText
        },
        secondary: {
            color: Core.surface.subdued,
            hover: Core.border.muted,
            contrast: Core.surface.default
        },
        label: {
            variant: "paragraphSansRegular"
        }
    }
});
